import InfiniteScroll from 'react-infinite-scroll-component';
import Card from './components/card';

import Title from './components/order';
import UseGetBuyers from './hooks/useGetBuyers';
import useHandleState from 'modules/Adds/hooks/useHandleState';
import CustomBottomSheet from 'components/bottomSheet';
import SortForm from './components/form';
import SearchInput from 'components/searchInput';
import useDebounce from 'utilities/hooks/debounce/useDebounce';
import DotsLoading from 'components/loadings/dotsLoading';
import EmptyPost from 'assets/images/emptyPage/empty page.svg';
const Buyers = ({app}: IBuyersProps) => {
  const {
    isSortOpen,
    sortFilter,
    search,
    setIsSortOpen,
    setsortFilter,
    setSearch,
  } = useHandleState();
  const newSearch = useDebounce(search, 500);
  const {buyers, fetchNextPage} = UseGetBuyers(app, sortFilter, newSearch);
  return (
    <>
      <div className="px-3 pt-3 pb-8">
        <div className="w-full">
          <SearchInput Search={search} setSearch={setSearch} />
        </div>
        <div className="py-4">
          <Title
            setIsSortOpen={setIsSortOpen}
            isSortOpen={isSortOpen}
            sortFilter={sortFilter}
          />
        </div>

        <InfiniteScroll
          dataLength={buyers?.pages.flatMap(x => x.results).length || 0} //This is important field to render the next data
          next={() => {
            fetchNextPage();
          }}
          style={{overflow: 'inherit'}}
          className="container  overflow-inherit"
          hasMore={!!buyers?.pages[buyers?.pages.length - 1].next}
          loader={<DotsLoading />}
          scrollableTarget="scrollableDiv"
        >
          {buyers?.pages.length === 0 ? (
            <div className=" mt-28">
              <img src={EmptyPost} alt="empty" className=" block mx-auto" />
              <p className=" text-gray-5 text-center">
                موردی برای نمایش وجود ندارد.
              </p>
            </div>
          ) : (
            buyers?.pages
              .flatMap(x => x.results)
              .map((item, index) => (
                <div className=" my-4" key={index}>
                  <Card
                    post_type={item.post_type}
                    title={item?.title}
                    icon={item?.product_category?.icon}
                    key={index}
                    state={item.state}
                    city={item.city}
                    createdAt={item.created_at}
                    quality={item.quality}
                    hidePhoneNumber={item.hide_phone_number}
                    guid={item.guid}
                    type={item.profile_type}
                    app={app}
                  />
                </div>
              ))
          )}
        </InfiniteScroll>
        <CustomBottomSheet
          isOpen={isSortOpen}
          onDismiss={() => setIsSortOpen(false)}
        >
          <SortForm
            setsortFilter={setsortFilter}
            sortFilter={sortFilter}
            setIsSortOpen={setIsSortOpen}
          />
        </CustomBottomSheet>
      </div>
    </>
  );
};

export default Buyers;
